<template>
    <auth>
        <b-form
            @submit.stop.prevent="onSubmit"
            @reset.stop.prevent="onReset"
            v-if="show"
            class="col-md-6 offset-md-3 text-center"
        >
            <b-form-group label="E-mail associado à conta:">
                <b-form-input
                    v-model="form.email"
                    type="email"
                    required
                    placeholder="Digite o seu email"
                ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">Recuperar</b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button type="reset" variant="danger">Limpar</b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button type="button" variant="warning" @click="goback">Voltar</b-button>
        </b-form>
    </auth>
</template>

<script>
import Auth from "./../layouts/Auth";
import Swal from "sweetalert2";
import { recoverAction } from "./../configs/services";
import Bus from "./../configs/bus";

export default {
    name: "Signup",
    components: {
        Auth
    },
    data() {
        return {
            form: {
                email: ""
            },
            show: true
        };
    },
    methods: {
        goback(){
            window.history.back();
        },
        onSubmit(evt) {
            console.log(JSON.stringify(this.form));

            Bus.$emit("toggle", null);
            
            recoverAction(this.form)
            .then(item => {
                console.log(item);
                Swal.fire("Sucesso!", "E-mail de recuperação enviado com sucesso!", "success");
            })
            .catch(this.errorHandler)
            .then(function() {
                Bus.$emit("toggle", null);
            });
        },
        onReset(evt) {
            // Reset our form values
            this.form = {
                email: "",
                fullname: "",
                country: "BRA",
                jobs: [],
                password: ""
            };
            // Trick to reset/clear native browser form validation state
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        }
    }
};
/* eslint-disable no-console */
//import axios from 'axios';
//import VueElementLoading from 'vue-element-loading';
//import { apiServer } from './../configs/enviroment';
// import Cookies from 'js-cookie';

// export default {
//   name: 'signup',
//   components: {
//     Auth
//   },
//   data(){
//     return {
//       user: {
//         fullname: '',
//         email: '',
//         password: '',
//         password_confirmation: ''
//       }
//     }
//   },
//   methods: {
//     signup(){
//       Bus.$emit('toggle', null);

//     },
//     clear(){
//       this.user = {
//         fullname: '',
//         email: '',
//         password: '',
//       };
//     }
//   }
// }
</script>
